<template>
  <section class="tutorial" id="tutorial">
    <div class="container">

      <div class="section-intro">
        <div class="section-tag">使用教程</div>
      </div>


      <div class="steps">
        <div class="step-item" v-for="(step, idx) in steps" :key="idx">
          <div class="step-number">{{ idx + 1 }}</div>
          <div class="step-content">
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </div>


      <div class="video-wrapper">
        <iframe
            src="//player.bilibili.com/player.html?bvid=BV1nVdaBFEHd&vd_source=fd07211833933e37a37d30d4224308ab&autoplay=0"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true">
        </iframe>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'SiteTutorial',
  data() {
    return {
      steps: [
        { title: '设置图库目录', desc: '设置一个本地文件夹作为图库目录' },
        { title: '等待导入完成', desc: 'AI分析图库，建立索引' },
        { title: '一键搜索', desc: '以图搜图' }
      ]
    }
  }
}
</script>

<style scoped>
.tutorial {
  padding: 48px 0;
  background: #fff;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 32px;
}

.section-intro {
  text-align: center;
  margin-bottom: 40px;
}

.section-tag {
  display: inline-block;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 20px;
  margin-bottom: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
  border: 1px solid rgba(37, 99, 235, 0.15);
}

.section-intro h2 {
  font-size: 34px;
  font-weight: 800;
  color: #1a202c;
  margin: 0;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  margin-bottom: 48px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 48px;
}

.step-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  transition: all 0.25s ease;
}

.step-item:hover {
  border-color: rgba(78, 140, 255, 0.3);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}

.step-number {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #4e8cff, #6ec1e4);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  margin: 0 auto 16px;
}

.step-content h3 {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 8px;
}

.step-content p {
  font-size: 13px;
  color: #718096;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 540px) {
  .steps { grid-template-columns: 1fr; }
  .container { padding: 0 16px; }
}
</style>
